import React, { Component } from 'react';
import { Dialog } from '@blueprintjs/core';
import { DateRangePicker } from '@blueprintjs/datetime';
import format from 'date-fns/format';
import addDays from 'date-fns/add_days';
import ComboBoxSearch from './ComboBoxSearch';
import GameCard from './cards/GameCard';

class GamesList extends Component {
  state = {
    loadedGames: false,
    isOpen: false,
    filteringGames: false,
    filters: {
      startDate: new Date(Date.now()),
      endDate: addDays(new Date(Date.now()), 1),
      division: '',
      team: '',
      umpire: '',
      levelNeeded: '',
      levelAssigned: ''
    },
    selectedOption: ''
  };

  componentDidMount(){
    const {
      getSeasonDivisions,
      getUmpInfo,
      userSeason
    } = this.props;

    getUmpInfo();
    if (userSeason) {
      this.updateGames(userSeason);
      getSeasonDivisions(userSeason);
    }
  }

  componentDidUpdate(prevProps) {
    const { userSeason, getSeasonDivisions } = this.props;
    if (userSeason !== prevProps.userSeason) {
      this.updateGames(userSeason);
      getSeasonDivisions(userSeason);
    }
  }

  handleSelectChange = event => {
    const { id, value } = event.target;

    let newValue = value === 'all' ? '' : value;
    if (id === 'division') {
      const teamValue = this.state.filters.division !== value ? '' : this.state.filters.team;
      this.setState(
        (prevState, props) => ({
          ...prevState,
          filteringGames: true,
          filters: { ...prevState.filters, division: newValue, team: teamValue }
        }),
        this.handleFilterGames
      );
      this.props.getTeams(value, this.props.userSeason);
    } else {
      this.setState(
        (prevState, props) => ({
          ...prevState,
          filteringGames: true,
          filters: { ...prevState.filters, [id]: newValue }
        }),
        this.handleFilterGames
      );
    }
  };

  handleFilterDate = selectedDate => {
    this.setState(
      (prevState, props) => ({
        ...prevState,
        filteringGames: true,
        filters: { ...prevState.filters, startDate: selectedDate[0], endDate: selectedDate[1] }
      }),
      this.handleFilterGames
    );
  };

  handleUmpireChange = selectedOption => {
    if (selectedOption !== null) {
      this.setState(
        (prevState, props) => ({
          ...prevState,
          filteringGames: true,
          filters: { ...prevState.filters, umpire: selectedOption.value },
          selectedOption
        }),
        this.handleFilterGames
      );
    } else {
      this.setState(
        (prevState, props) => ({
          ...prevState,
          filteringGames: true,
          filters: { ...prevState.filters, umpire: '' },
          selectedOption: ''
        }),
        this.handleFilterGames
      );
    }
  };

  removeFilters = () => {
    this.setState(
      (prevState, props) => ({
        ...prevState,
        filteringGames: false,
        filters: {
          startDate:  new Date(Date.now()),
          endDate: addDays(new Date(Date.now()), 1),
          division: '',
          team: '',
          umpire: '',
          levelNeeded: '',
          levelAssigned: ''
        },
        selectedOption: ''
      }),
      this.handleFilterGames
    );
  };

  updateGames = newUserSeason => {
    let endDate =
      this.state.filters.endDate === null
        ? this.state.filters.startDate
        : this.state.filters.endDate;
    endDate = endDate === null ? null : format(endDate, 'MM/DD/YYYY');
    this.props.filterGames(
      format(this.state.filters.startDate, 'MM/DD/YYYY'),
      endDate,
      newUserSeason,
      this.state.filters.division,
      this.state.filters.team,
      this.state.filters.umpire,
      true,
      true
    );
  };

  handleFilterGames = () => {
    let endDate =
      this.state.filters.endDate === null
        ? this.state.filters.startDate
        : this.state.filters.endDate;
    endDate = endDate === null ? null : format(endDate, 'MM/DD/YYYY');
    this.props.filterGames(
      format(this.state.filters.startDate, 'MM/DD/YYYY'),
      endDate,
      this.props.userSeason,
      this.state.filters.division,
      this.state.filters.team,
      this.state.filters.umpire,
      true,
      true
    );
  };

  handleFilterDialog = event => {
    this.setState({ ...this.state, isOpen: !this.state.isOpen });
  };

  isAdmin = () => {
    return this.props.userType === 'Admin';
  };

  allLoaded = () => {
    //Check that all required state objects have been loaded
    const {
      fetchingFilteredGamesStatus, fetchingSeasonDivisionsStatus, fetchingUmpiresStatus
    } = this.props;
    return  fetchingFilteredGamesStatus === 'Loaded' &&
            fetchingSeasonDivisionsStatus === 'Loaded' && fetchingUmpiresStatus === 'Loaded';
  }

  getUmpireLevelNeeded = game => {
    const { seasonDivisions } = this.props;
    const umpsRequested =
      game.umpAvailable === null || game.umpAvailable === '' ? 1 : game.umpAvailable;
    let gameLevel = 10;  //Default, no Umpire Needed
    let nextLevel;

    //Determine the lowest Level of Umpire still required for the game
    if (!game.umpPlateId)
      gameLevel =
        !seasonDivisions[game.divisionId].umpPlateLevel ? 2 : seasonDivisions[game.divisionId].umpPlateLevel;
    if ((umpsRequested >= 2) && (!game.umpBase1Id)) {
      nextLevel =
        !seasonDivisions[game.divisionId].umpBase1Level ? 1 : seasonDivisions[game.divisionId].umpBase1Level;
      gameLevel = nextLevel < gameLevel ? nextLevel : gameLevel;
    }
    if ((umpsRequested >= 3) && (!game.umpBase2Id)) {
      nextLevel =
        !seasonDivisions[game.divisionId].umpBase2Level ? 1 : seasonDivisions[game.divisionId].umpBase2Level;
      gameLevel = nextLevel < gameLevel ? nextLevel : gameLevel;
    }
    if ((umpsRequested >= 4) && (!game.umpBase2Id)) {
      nextLevel =
        !seasonDivisions[game.divisionId].umpBase3Level ? 1 : seasonDivisions[game.divisionId].umpBase3Level;
      gameLevel = nextLevel < gameLevel ? nextLevel : gameLevel;
    }
    return gameLevel;
  }

  renderFilter() {
    const {
      seasonDivisions,
      seasonDivisionsList,
      teams,
      teamsList,
      umpiresList,
    } = this.props;
    return (
      <div className="filter-objects">
        <div className="game-filters-btn">
          <button className="pt-button" onClick={this.handleFilterDialog}>
           Filters
           </button>
        </div>
        <Dialog
          className="games-filter-dialog"
          isOpen={this.state.isOpen}
          title="Game Filters"
          onClose={this.handleFilterDialog}
        >
          <div className="game-filters-container">
            <label className="pt-label pt-inline date-range">
              Select Date:
              <DateRangePicker
                format="MM/DD/YYYY"
                allowSingleDayRange={true}
                closeOnSelection={true}
                value={[this.state.filters.startDate, this.state.filters.endDate]}
                onChange={this.handleFilterDate}
                shortcuts={false}
              />
            </label>
            <label className="pt-label pt-inline">
              Division:
              <select
                className="pt-input"
                id="division"
                value={this.state.filters.division}
                onChange={this.handleSelectChange}
              >
                <option key="divisions-all" value="all">
                  All Division
                </option>
                {seasonDivisionsList.map(divisionId => {
                  return (
                    <option key={divisionId} value={divisionId}>
                      {seasonDivisions[divisionId].name}
                    </option>
                  );
                })}
              </select>
            </label>
            <label className="pt-label pt-inline">
              Teams:
              <select
                className="pt-input"
                id="team"
                value={this.state.filters.team}
                onChange={this.handleSelectChange}
              >
                <option key="teams-all" value="all">
                  All Teams
                </option>
                {teamsList.map(teamId => {
                  return (
                    <option key={teamId} value={teamId}>
                      {teams[teamId].name}
                    </option>
                  );
                })}
              </select>
            </label>
            <label className="pt-label pt-inline umpire-label">
              Umpire:
              <ComboBoxSearch
                // className="umpire-select"
                placeholder="Select umpire"
                items={umpiresList}
                selectedOption={this.state.selectedOption}
                onItemChange={selectedOption => this.handleUmpireChange(selectedOption)}
              />
            </label>
            <label className="pt-label pt-inline level-label">
              Level Assigned:
              <select
                className="pt-input"
                id="levelAssigned"
                value={this.state.filters.levelAssigned}
                onChange={this.handleSelectChange}
              >
                <option key="levels-all" value="all">All Levels</option>
                {[1,2,3,4,5,6,7].map(i => {
                  return(<option key={`level-${i}`} value={i}>{i}</option>)
                })}
              </select>
            </label>
            <label className="pt-label pt-inline level-label">
              Level Needed:
              <select
                className="pt-input"
                id="levelNeeded"
                value={this.state.filters.levelNeeded}
                onChange={this.handleSelectChange}
              >
                <option key="levels-all" value="all">All Levels</option>
                {[1,2,3,4,5,6,7].map(i => {
                  return(<option key={`level-${i}`} value={i}>{i}</option>)
                })}
              </select>
            </label>
            <div className="game-filters-clear-btn">
              <button className="pt-button" onClick={this.removeFilters}>
                Clear
              </button>
              <button className="pt-button" onClick={this.handleFilterDialog} style={{marginLeft: 5}}>
                Ok
              </button>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }

  render() {
    const {
      filteredGamesList,
      games,
      umpires,
      umpiresList,
      fetchingUmpiresStatus,
      memberId,
    } = this.props;

    let outputList = [];

    if (this.allLoaded()) {
      if(this.state.filters.levelAssigned !== '' && this.state.filters.levelNeeded !== ''){
        filteredGamesList
        .filter(game => (this.state.filters.levelAssigned === games[game].umpPlateLevel ||
            this.state.filters.levelAssigned === games[game].umpBase1Level ||
            this.state.filters.levelAssigned === games[game].umpBase2Level ||
            this.state.filters.levelAssigned === games[game].umpBase3Level) &&
            (this.getUmpireLevelNeeded(games[game]) <= this.state.filters.levelNeeded))
        .map((game) => {
          return outputList.push(game);
        });
      } else if(this.state.filters.levelAssigned !== '' && this.state.filters.levelNeeded === ''){
        filteredGamesList
        .filter(game => this.state.filters.levelAssigned === games[game].umpPlateLevel ||
            this.state.filters.levelAssigned === games[game].umpBase1Level ||
            this.state.filters.levelAssigned === games[game].umpBase2Level ||
            this.state.filters.levelAssigned === games[game].umpBase3Level)
        .map((game) => {
          return outputList.push(game);
        });
      } else if(this.state.filters.levelAssigned === '' && this.state.filters.levelNeeded !== ''){
        filteredGamesList
        .filter(game => this.getUmpireLevelNeeded(games[game]) <= this.state.filters.levelNeeded)
        .map((game) => {
          return outputList.push(game);
        });
      } else {
        outputList = filteredGamesList;
      }
    }

    return (
      <div className="games-list-container report-list-container-main">
        <div className="report-list-table-header">
          <h1 className="left">Games Table</h1>
          {this.renderFilter()}
        </div>
        <table className="games-list List-Table">
          <thead>
            <tr>
              <th>Game Information</th>
              <th>Umpires</th>
            </tr>
          </thead>
          <tbody>
            {this.allLoaded() ?
              outputList.length > 0 ? (
                outputList.map((id, index) => {
                  return (
                    <tr className="row-highlighter" key={games[id].id}>
                      <td>
                        <GameCard
                          games={games}
                          gameId={id}
                          umpires={umpires}
                          umpiresList={umpiresList}
                          fetchingUmpiresStatus={fetchingUmpiresStatus}
                          memberId={memberId}
                          isUmpire={false}
                          isAdmin={this.isAdmin()}
                          isCoach={false}
                          assignUmpToGame={this.props.assignUmpToGame}
                          removeUmp={this.props.removeUmp}
                          updateUmpAvailableForGame={this.props.updateUmpAvailableForGame}
                          allowsAssigning={true}
                          seasonDivisions={this.props.seasonDivisions}
                          isRow={true}
                        />
                      </td>
                    </tr>
                  );
                })
                ): (
                  <tr className="row-highlighter">
                    <td>No games found, try adjusting your filter.</td>
                  </tr>
                )
            :
              <tr className="row-highlighter">
                <td>Loading Games....</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    );
  }
}

export default GamesList;



// WEBPACK FOOTER //
// ./src/components/GamesListV2.js